import { z } from 'zod';
import type { CustomerAction, CustomerActionKind } from '../types';

/** Every support write carries a reason; credits carry a signed delta; impersonation a mode. */
export const actionSchema = z.object({
  reason: z.string().trim().min(8, 'Say why, in at least a few words'),
  delta: z.coerce
    .number()
    .int()
    .refine((n) => n !== 0, 'Zero changes nothing')
    .optional(),
  mode: z.enum(['read', 'write']).optional(),
});

export type ActionFormValues = z.output<typeof actionSchema>;
export type ActionFormInput = z.input<typeof actionSchema>;

export const actionWord: Record<CustomerActionKind, string> = {
  pause_intake: 'Pause intake',
  resume_intake: 'Resume intake',
  pause_export: 'Pause export',
  resume_export: 'Resume export',
  adjust_credits: 'Adjust pages',
  impersonate: 'Impersonate',
};

export const actionEffect: Record<CustomerActionKind, string> = {
  pause_intake: 'New pages are held at the source; nothing already in flight is lost.',
  resume_intake: 'Held pages start moving again.',
  pause_export: 'Documents finish reading and wait at export.',
  resume_export: 'Waiting documents deliver in order.',
  adjust_credits: 'Mirrored to Phone Home admin events with your name and the reason.',
  impersonate: 'A recorded grant; every action you take is audited as a support action.',
};

export function toCustomerAction(kind: CustomerActionKind, v: ActionFormValues): CustomerAction {
  const action: CustomerAction = { kind, reason: v.reason };
  if (kind === 'adjust_credits' && v.delta !== undefined) action.delta = v.delta;
  if (kind === 'impersonate') action.mode = v.mode ?? 'read';
  return action;
}
